import React from 'react';

const SVG = ({width = '16px', height = '16px'}) => (
  <svg
    width={width}
    height={height}
    viewBox="0 2 40 25"
    className="bi bi-truck"
    fill="currentColor"
    xmlns="http://www.w3.org/2000/svg"
  >
    <title>Truck</title>
    <g fillRule="evenodd">
      <path d="M8.7,21.48a3.77,3.77,0,1,0,3.77,3.77A3.77,3.77,0,0,0,8.7,21.48Zm0,5A1.25,1.25,0,1,1,10,25.25,1.25,1.25,0,0,1,8.7,26.51Z"></path>
      <path d="M29.9,21.48a3.77,3.77,0,1,0,3.77,3.77A3.77,3.77,0,0,0,29.9,21.48Zm0,5a1.25,1.25,0,1,1,1.25-1.25A1.25,1.25,0,0,1,29.9,26.51Z"></path>
      <path d="M37.59,21h-.26V11.65a2.68,2.68,0,0,0-.47-1.39L32.58,4.62A1.77,1.77,0,0,0,31.33,4h-7V.77A.77.77,0,0,0,23.59,0H4.26a3.09,3.09,0,0,0-3.1,3.09V21H.76a.76.76,0,0,0-.76.76v2.7a.77.77,0,0,0,.77.77H3.41a5.29,5.29,0,0,1,10.57,0H24.61a5.29,5.29,0,0,1,10.57,0h2.39a.77.77,0,0,0,.77-.77v-2.7A.75.75,0,0,0,37.59,21ZM26.33,11.45V6.93h3.22a1.66,1.66,0,0,1,1.18.59l2.88,3.93Z"></path>
    </g>
  </svg>
);

export default SVG;
